export default __webpack_public_path__ + "static/home-d166646569975ff01a5e02d7102da433.png";